// ABOUTME: Route for /skills — renders the user skills management page.
import { SkillsPage } from "@/components/skills/SkillsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/skills/")({
  component: SkillsPage,
});
